import UserSessionService from "../../services/UserSessionService";
import React, {Fragment} from "react";
import UserPaymentDetailsService from "../../services/admin/UserPaymentDetailsService";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import {Card, CardBody, CardGroup, Col, Form, Input, InputGroup} from "reactstrap";
import DropdownComponent from "../../components/DropdownComponent";
import CreateObjectRowWithLabelComponent from "../../components/CreateObjectRowWithLabelComponent";
import ToastHelper from "../../utils/ToastHelper";
import "../../scss/PaymentDetails.css";

const dropdownValues = [
    {name: "BANK_ACCOUNT", value: "Bank Account"},
    {name: "WALLET", value: "Wallet"}
]

const BANK_ACCOUNT = "BANK_ACCOUNT";
const WALLET = "WALLET";

export default class PaymentDetailsIndex extends React.Component {

    constructor(props) {
        super(props);

        this.props.changeHeader("Payment Details");

        let agentId = UserSessionService.getUser().user.id;
        let agentName = UserSessionService.getUser().user.firstName + ' ' + UserSessionService.getUser().user.lastName;

        this.state = {
            agentId: agentId,
            agentName: agentName,
            agentPaymentDetails: {},
            agentIsEditing: false,
            isLoading: true,
            paymentType: {},
            bankName: "",
            bankAccountNumber: "",
            branchCode: "",
            walletName: "",
            msisdn: "",
            paymentDetails: {}
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let agentPaymentDetails = {};
        let agentIsEditing = false;

        UserPaymentDetailsService.retrieveByUserId(this.state.agentId).then(response => {
            if (response["errors"]) {
                agentIsEditing = true;
            } else {
                agentPaymentDetails = response;
            }
            this.setState({
                agentPaymentDetails: agentPaymentDetails,
                agentIsEditing: agentIsEditing,
                isLoading: false
            })
        });
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        })
    }

    onPaymentTypeChange(selectedPaymentType) {
        if (selectedPaymentType !== null) {
            this.setState({
                paymentType: selectedPaymentType,
                bankName: "",
                bankAccountNumber: "",
                branchCode: "",
                walletName: "",
                msisdn: ""
            });
        }
    }

    onUpdateClick() {
        let newState = this.state;
        let paymentDetails = {};
        paymentDetails.id = 0;
        paymentDetails.userId = newState.agentId;
        paymentDetails.creatingUserId = newState.agentId;
        paymentDetails.paymentTypeDetailsId = 0;
        paymentDetails.bankName = newState.bankName;
        paymentDetails.bankAccountNumber = newState.bankAccountNumber;
        paymentDetails.branchCode = newState.branchCode;
        paymentDetails.walletName = newState.walletName;
        paymentDetails.msisdn = newState.msisdn;
        paymentDetails.userPaymentType = newState.paymentType.name;
        paymentDetails.active = true;

        this.setState({
            isLoading: true
        }, () => this.updateOrCreate(paymentDetails));

    }

    updateOrCreate(paymentDetails) {
        UserPaymentDetailsService.createAndUpdateUserPaymentDetails(paymentDetails.userId, paymentDetails).then(response => {
            if (response["errors"]) {
                ToastHelper.formatError(response);
            }
            this.setState({
                isLoading: false
            }, () => this.loadData());
        })
    }

    onEditButtonClick() {
        this.setState({
            agentIsEditing: true
        });
    }

    onCancelClick() {
        this.setState({
            agentIsEditing: false,
            paymentType: this.state.agentPaymentDetails.userPaymentType,
            bankName: "",
            bankAccountNumber: "",
            branchCode: "",
            walletName: "",
            msisdn: ""
        });
    }

    render() {
        return <Fragment>
            {this.state.isLoading ? <SFXLoadingComponent/>
                :
                <Fragment>
                    <CardGroup className={"cardGroup"}>
                        <Card className="p-2" style={{borderRadius: "0.6rem"}}>
                            <CardBody>
                                <Form onSubmit={this.handleSubmit}>
                                    <Col>
                                        {Object.keys(this.state.agentPaymentDetails).length === 0 &&
                                        <Fragment>
                                            {this.renderFirstTimePaymentDetails()}
                                        </Fragment>
                                        }
                                        {this.state.agentIsEditing ?
                                            <Fragment>
                                                {this.renderEditDetails()}
                                            </Fragment>
                                            :
                                            <Fragment>
                                                {this.renderViewDetails()}
                                            </Fragment>
                                        }
                                    </Col>
                                </Form>
                            </CardBody>
                        </Card>
                    </CardGroup>
                </Fragment>
            }
        </Fragment>
    }

    renderBankAccountDetails() {
        return <Fragment>
            <InputGroup className="mb-3">
                <Input className="form-control input-lg"
                       type="text"
                       placeholder="Bank Name"
                       autoComplete="bankName"
                       id="bankName"
                       autoFocus
                       onChange={this.handleChange}
                       value={this.state.bankName}/>
            </InputGroup>
            <InputGroup className="mb-3">
                <Input className="form-control input-lg"
                       type="number"
                       placeholder="Bank Account Number"
                       id="bankAccountNumber"
                       autoComplete="bankAccountNumber"
                       onChange={this.handleChange}
                       value={this.state.bankAccountNumber}/>
            </InputGroup>
            <InputGroup className="mb-3">
                <Input className="form-control input-lg"
                       type="number"
                       placeholder="Branch Code"
                       id="branchCode"
                       autoComplete="branchCode"
                       onChange={this.handleChange}
                       value={this.state.branchCode}/>
            </InputGroup>
        </Fragment>
    }

    renderWalletDetails() {
        return <Fragment>
            <InputGroup className="mb-3">
                <Input className="form-control input-lg"
                       type="text"
                       placeholder="Wallet Name"
                       id="walletName"
                       autoComplete="walletName"
                       onChange={this.handleChange}
                       value={this.state.walletName}/>
            </InputGroup>
            <InputGroup className="mb-3">
                <Input className="form-control input-lg"
                       type="text"
                       placeholder="Cellphone Number"
                       id="msisdn"
                       autoComplete="msisdn"
                       onChange={this.handleChange}
                       value={this.state.msisdn}/>
            </InputGroup>
        </Fragment>
    }

    renderEditDetails() {
        return <Fragment>
            <DropdownComponent
                options={dropdownValues}
                optionValue={"name"}
                optionText={"value"}
                placeholder={"Type of Payment"}
                disableSearch={true}
                onChange={(selectedOption) => {
                    this.onPaymentTypeChange(selectedOption);
                }}
            />

            <br />

            {this.state.paymentType.name === BANK_ACCOUNT && this.renderBankAccountDetails()}
            {this.state.paymentType.name === WALLET && this.renderWalletDetails()}
            <hr />
            {this.renderInEditButtons()}
        </Fragment>
    }

    renderViewDetails() {
        let state = this.state.agentPaymentDetails;
        return <Fragment>
            {state.userPaymentType === BANK_ACCOUNT ?
                <Fragment>
                    <div style={{textAlign: "center"}}>
                        <CreateObjectRowWithLabelComponent label={"Bank Name"} className={'pull-left'}>
                            {state.bankName}
                        </CreateObjectRowWithLabelComponent>
                        <CreateObjectRowWithLabelComponent label={"Bank Account Number"} className={'pull-left'}>
                            {state.bankAccountNumber}
                        </CreateObjectRowWithLabelComponent>
                        <CreateObjectRowWithLabelComponent label={"Branch Code"} className={'pull-left'}>
                            {state.branchCode}
                        </CreateObjectRowWithLabelComponent>
                    </div>
                </Fragment>
                :
                <Fragment>
                    <div style={{textAlign: "center"}}>
                        <CreateObjectRowWithLabelComponent label={"Wallet Name"} className={'pull-left'}>
                            {state.walletName}
                        </CreateObjectRowWithLabelComponent>
                        <CreateObjectRowWithLabelComponent label={"Cellphone Number"} className={'pull-left'}>
                            {state.msisdn}
                        </CreateObjectRowWithLabelComponent>
                    </div>
                </Fragment>
            }
            <hr />
            {this.renderInViewButtons()}
        </Fragment>
    }

    renderFirstTimePaymentDetails() {
        return <Fragment>
            <h5 style={{textAlign: "center"}}>Hi {this.state.agentName}</h5>
            <br />
            Please choose between bank account or mobile wallet and enter your details
            <br />
            <br />
        </Fragment>
    }

    renderInEditButtons() {
        return <Fragment>
            <div>
                <SFXButtonComponent onClick={this.onCancelClick.bind(this)}>
                    Cancel
                </SFXButtonComponent>
                {'  '}
                {this.state.paymentType.name === BANK_ACCOUNT ?
                    <SFXButtonComponent onClick={this.onUpdateClick.bind(this)}
                                        hidden={(this.state.bankName === "" || this.state.bankAccountNumber === "" || this.state.branchCode === "")}
                                        className={"btn-primary"}>
                        Update
                    </SFXButtonComponent>
                    :
                    <SFXButtonComponent onClick={this.onUpdateClick.bind(this)}
                                        hidden={(!this.state.msisdn.match(/^[0-9,+][0-9]{9,14}$/) || this.state.walletName === "")}
                                        className={"btn-primary"}>
                        Update
                    </SFXButtonComponent>
                }
            </div>
        </Fragment>
    }

    renderInViewButtons() {

        return <Fragment>
            <SFXButtonComponent onClick={this.onEditButtonClick.bind(this)} className={"btn-primary"}
                                style={{width: "100%", margin: "auto"}}>
                Edit
            </SFXButtonComponent>
        </Fragment>

    }
}
